// @flow
import React, { Component, type Node } from 'react';
import './UserTemplate.scss';

type Props = {
  children: Node,
};

class UserTemplate extends Component<Props> {
  render() {
    const { children } = this.props;
    return (
      <div className="UserTemplate">
        <div className="main">{children}</div>
      </div>
    );
  }
}

export default UserTemplate;



// WEBPACK FOOTER //
// ./src/components/user/UserTemplate/UserTemplate.js